var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.23877 0 0 2.23958 0 5C0 7.76204 2.23877 10 5 10C7.76123 10 10 7.76204 10 5C10 2.23958 7.76123 0 5 0ZM5 2.21774C5.46766 2.21774 5.84677 2.59685 5.84677 3.06452C5.84677 3.53218 5.46766 3.91129 5 3.91129C4.53234 3.91129 4.15323 3.53218 4.15323 3.06452C4.15323 2.59685 4.53234 2.21774 5 2.21774ZM6.12903 7.33871C6.12903 7.47232 6.02071 7.58065 5.8871 7.58065H4.1129C3.97929 7.58065 3.87097 7.47232 3.87097 7.33871V6.85484C3.87097 6.72123 3.97929 6.6129 4.1129 6.6129H4.35484V5.32258H4.1129C3.97929 5.32258 3.87097 5.21425 3.87097 5.08065V4.59677C3.87097 4.46317 3.97929 4.35484 4.1129 4.35484H5.40323C5.53683 4.35484 5.64516 4.46317 5.64516 4.59677V6.6129H5.8871C6.02071 6.6129 6.12903 6.72123 6.12903 6.85484V7.33871Z",
    fill: "#155892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d781c5f3c5e0a8fa138e97d765c28abf.svg";
export { ForwardRef as ReactComponent };